// Generated from the official OpenFoodFacts nutrients taxonomy:
// https://raw.githubusercontent.com/openfoodfacts/openfoodfacts-server/main/taxonomies/nutrients.txt

export const OFF_NUTRIENT_METADATA = Object.freeze(
[
  {
    "key": "energy-kj",
    "label": "Énergie (kJ)",
    "unit": "kJ"
  },
  {
    "key": "energy-kcal",
    "label": "Énergie (kcal)",
    "unit": "kcal"
  },
  {
    "key": "energy",
    "label": "Énergie",
    "unit": "kJ"
  },
  {
    "key": "energy-from-fat",
    "label": "Énergie provenant des graisses",
    "unit": "kJ"
  },
  {
    "key": "fat",
    "label": "Lipides",
    "unit": "g"
  },
  {
    "key": "saturated-fat",
    "label": "AG saturés",
    "unit": "g"
  },
  {
    "key": "butyric-acid",
    "label": "Acide butyrique",
    "unit": "g"
  },
  {
    "key": "caproic-acid",
    "label": "Acide caproïque",
    "unit": "g"
  },
  {
    "key": "caprylic-acid",
    "label": "Acide caprylique",
    "unit": "g"
  },
  {
    "key": "capric-acid",
    "label": "Acide caprique",
    "unit": "g"
  },
  {
    "key": "lauric-acid",
    "label": "Acide laurique",
    "unit": "g"
  },
  {
    "key": "myristic-acid",
    "label": "Acide myristique",
    "unit": "g"
  },
  {
    "key": "palmitic-acid",
    "label": "Acide palmitique",
    "unit": "g"
  },
  {
    "key": "Psicose",
    "label": "Psicose",
    "unit": "g"
  },
  {
    "key": "stearic-acid",
    "label": "Acide stéarique",
    "unit": "g"
  },
  {
    "key": "arachidic-acid",
    "label": "Acide arachidique",
    "unit": "g"
  },
  {
    "key": "behenic-acid",
    "label": "Acide béhénique",
    "unit": "g"
  },
  {
    "key": "lignoceric-acid",
    "label": "Acide lignocérique",
    "unit": "g"
  },
  {
    "key": "cerotic-acid",
    "label": "Acide cérotique",
    "unit": "g"
  },
  {
    "key": "montanic-acid",
    "label": "Acide montanique",
    "unit": "g"
  },
  {
    "key": "melissic-acid",
    "label": "Acide mélissique",
    "unit": "g"
  },
  {
    "key": "unsaturated-fat",
    "label": "Unsaturated fat",
    "unit": "g"
  },
  {
    "key": "monounsaturated-fat",
    "label": "AG monoinsaturés",
    "unit": "g"
  },
  {
    "key": "polyunsaturated-fat",
    "label": "AG polyinsaturés",
    "unit": "g"
  },
  {
    "key": "omega-3-fat",
    "label": "Acides gras Oméga 3",
    "unit": "mg"
  },
  {
    "key": "alpha-linolenic-acid",
    "label": "Acide alpha-linolénique",
    "unit": "g"
  },
  {
    "key": "eicosapentaenoic-acid",
    "label": "Acide eicosapentaénoïque",
    "unit": "g"
  },
  {
    "key": "docosahexaenoic-acid",
    "label": "Acide docosahexaénoïque",
    "unit": "g"
  },
  {
    "key": "omega-6-fat",
    "label": "Acides gras Oméga 6",
    "unit": "mg"
  },
  {
    "key": "linoleic-acid",
    "label": "Acide linoléique",
    "unit": "g"
  },
  {
    "key": "arachidonic-acid",
    "label": "Acide arachidonique",
    "unit": "g"
  },
  {
    "key": "gamma-linolenic-acid",
    "label": "Acide gamma-linolénique",
    "unit": "g"
  },
  {
    "key": "dihomo-gamma-linolenic-acid",
    "label": "Acide dihomo-gamma-linolénique",
    "unit": "g"
  },
  {
    "key": "omega-9-fat",
    "label": "Acides gras Oméga 9",
    "unit": "mg"
  },
  {
    "key": "oleic-acid",
    "label": "Acide oléique",
    "unit": "g"
  },
  {
    "key": "elaidic-acid",
    "label": "Acide élaïdique",
    "unit": "g"
  },
  {
    "key": "gondoic-acid",
    "label": "Acide gadoléique",
    "unit": "g"
  },
  {
    "key": "mead-acid",
    "label": "Acide de Mead",
    "unit": "g"
  },
  {
    "key": "erucic-acid",
    "label": "Acide érucique",
    "unit": "g"
  },
  {
    "key": "nervonic-acid",
    "label": "Acide nervonique",
    "unit": "g"
  },
  {
    "key": "trans-fat",
    "label": "AG trans",
    "unit": "g"
  },
  {
    "key": "cholesterol",
    "label": "Cholestérol",
    "unit": "mg"
  },
  {
    "key": "gamma-oryzanol",
    "label": "oryzanol",
    "unit": "mg"
  },
  {
    "key": "carbohydrates-total",
    "label": "Glucides totaux (inclut les fibres)",
    "unit": "g"
  },
  {
    "key": "carbohydrates",
    "label": "Glucides",
    "unit": "g"
  },
  {
    "key": "sugars",
    "label": "Sucres",
    "unit": "g"
  },
  {
    "key": "added-sugars",
    "label": "Sucres ajoutés",
    "unit": "g"
  },
  {
    "key": "sucrose",
    "label": "Saccharose",
    "unit": "g"
  },
  {
    "key": "glucose",
    "label": "Glucose",
    "unit": "g"
  },
  {
    "key": "fructose",
    "label": "Fructose",
    "unit": "g"
  },
  {
    "key": "oligosaccharide",
    "label": "Oligosaccharide",
    "unit": "g"
  },
  {
    "key": "lactose",
    "label": "Lactose",
    "unit": "g"
  },
  {
    "key": "galactose",
    "label": "Galactose",
    "unit": "g"
  },
  {
    "key": "maltose",
    "label": "Maltose",
    "unit": "g"
  },
  {
    "key": "maltodextrins",
    "label": "Maltodextrines",
    "unit": "g"
  },
  {
    "key": "starch",
    "label": "Amidon",
    "unit": "g"
  },
  {
    "key": "Polydextrose",
    "label": "Polydextrose",
    "unit": "g"
  },
  {
    "key": "polyols",
    "label": "Polyols",
    "unit": "g"
  },
  {
    "key": "Erythritol",
    "label": "Érythritol",
    "unit": "g"
  },
  {
    "key": "Isomalt",
    "label": "Isomalt",
    "unit": "g"
  },
  {
    "key": "Maltitol",
    "label": "Maltitol",
    "unit": "g"
  },
  {
    "key": "Sorbitol",
    "label": "Sorbitol",
    "unit": "g"
  },
  {
    "key": "fiber",
    "label": "Fibres",
    "unit": "g"
  },
  {
    "key": "soluble-fiber",
    "label": "Fibres solubles",
    "unit": "g"
  },
  {
    "key": "insoluble-fiber",
    "label": "Fibres insolubles",
    "unit": "g"
  },
  {
    "key": "proteins",
    "label": "Protéines",
    "unit": "g"
  },
  {
    "key": "casein",
    "label": "Caséine",
    "unit": "g"
  },
  {
    "key": "serum-proteins",
    "label": "Protéines sériques",
    "unit": "g"
  },
  {
    "key": "nucleotides",
    "label": "Nucléotides",
    "unit": "g"
  },
  {
    "key": "salt",
    "label": "Sel",
    "unit": "g"
  },
  {
    "key": "added-salt",
    "label": "Sel ajouté",
    "unit": "g"
  },
  {
    "key": "sodium",
    "label": "Sodium",
    "unit": "g"
  },
  {
    "key": "alcohol",
    "label": "Alcool",
    "unit": "% vol"
  },
  {
    "key": "vitamin-a",
    "label": "Vitamine A",
    "unit": "µg"
  },
  {
    "key": "beta-carotene",
    "label": "Bêta-carotène",
    "unit": "g"
  },
  {
    "key": "vitamin-d",
    "label": "Vitamine D",
    "unit": "µg"
  },
  {
    "key": "vitamin-e",
    "label": "Vitamine E",
    "unit": "mg"
  },
  {
    "key": "vitamin-k",
    "label": "Vitamine K",
    "unit": "µg"
  },
  {
    "key": "vitamin-c",
    "label": "Vitamine C",
    "unit": "mg"
  },
  {
    "key": "vitamin-b1",
    "label": "Vitamine B1",
    "unit": "mg"
  },
  {
    "key": "vitamin-b2",
    "label": "Vitamine B2",
    "unit": "mg"
  },
  {
    "key": "vitamin-pp",
    "label": "Vitamine B3/PP",
    "unit": "mg"
  },
  {
    "key": "vitamin-b6",
    "label": "Vitamine B6",
    "unit": "mg"
  },
  {
    "key": "vitamin-b9",
    "label": "Vitamine B9",
    "unit": "µg"
  },
  {
    "key": "folates",
    "label": "Folates (folates totaux)",
    "unit": "µg"
  },
  {
    "key": "vitamin-b12",
    "label": "Vitamine B12",
    "unit": "µg"
  },
  {
    "key": "biotin",
    "label": "Biotine (Vitamine B8 ou B7 ou H)",
    "unit": "µg"
  },
  {
    "key": "pantothenic-acid",
    "label": "Vitamine B5 (Acide pantothénique)",
    "unit": "mg"
  },
  {
    "key": "silica",
    "label": "Silice",
    "unit": "mg"
  },
  {
    "key": "bicarbonate",
    "label": "Bicarbonate",
    "unit": "mg"
  },
  {
    "key": "Sulphate",
    "label": "Sulfate",
    "unit": "mg"
  },
  {
    "key": "Nitrate",
    "label": "Nitrate",
    "unit": "mg"
  },
  {
    "key": "Hydrogencarbonate",
    "label": "Hydrogencarbonate",
    "unit": ""
  },
  {
    "key": "Nitrite",
    "label": "Nitrite",
    "unit": ""
  },
  {
    "key": "potassium",
    "label": "Potassium",
    "unit": "mg"
  },
  {
    "key": "chloride",
    "label": "Chlorure",
    "unit": "mg"
  },
  {
    "key": "calcium",
    "label": "Calcium",
    "unit": "mg"
  },
  {
    "key": "phosphorus",
    "label": "Phosphore",
    "unit": "mg"
  },
  {
    "key": "iron",
    "label": "Fer",
    "unit": "mg"
  },
  {
    "key": "magnesium",
    "label": "Magnésium",
    "unit": "mg"
  },
  {
    "key": "zinc",
    "label": "Zinc",
    "unit": "mg"
  },
  {
    "key": "copper",
    "label": "Cuivre",
    "unit": "mg"
  },
  {
    "key": "manganese",
    "label": "Manganèse",
    "unit": "mg"
  },
  {
    "key": "fluoride",
    "label": "Fluorure",
    "unit": "mg"
  },
  {
    "key": "selenium",
    "label": "Sélénium",
    "unit": "µg"
  },
  {
    "key": "chromium",
    "label": "Chrome",
    "unit": "µg"
  },
  {
    "key": "molybdenum",
    "label": "Molybdène",
    "unit": "µg"
  },
  {
    "key": "iodine",
    "label": "Iode",
    "unit": "µg"
  },
  {
    "key": "caffeine",
    "label": "Caféine",
    "unit": "mg"
  },
  {
    "key": "taurine",
    "label": "Taurine",
    "unit": "g"
  },
  {
    "key": "ph",
    "label": "pH",
    "unit": ""
  },
  {
    "key": "fruits-vegetables-nuts",
    "label": "Fruits, légumes et oléagineux",
    "unit": "%"
  },
  {
    "key": "fruits-vegetables-nuts-dried",
    "label": "Fruits, légumes et oléagineux séchés",
    "unit": "%"
  },
  {
    "key": "fruits-vegetables-legumes",
    "label": "Fruits, légumes et légumineuses",
    "unit": "%"
  },
  {
    "key": "whole-grain",
    "label": "Céréales complètes",
    "unit": "%"
  },
  {
    "key": "collagen-meat-protein-ratio",
    "label": "Rapport collagène sur protéines de viande (maximum)",
    "unit": "%"
  },
  {
    "key": "cocoa",
    "label": "Cacao (minimum)",
    "unit": "%"
  },
  {
    "key": "chlorophyl",
    "label": "Chlorophylle",
    "unit": "g"
  },
  {
    "key": "carbon-footprint",
    "label": "Empreinte carbone",
    "unit": "g"
  },
  {
    "key": "glycemic-index",
    "label": "Indice glycémique",
    "unit": ""
  },
  {
    "key": "water-hardness",
    "label": "Dureté de l'eau",
    "unit": "mmol/l"
  },
  {
    "key": "choline",
    "label": "Choline",
    "unit": "g"
  },
  {
    "key": "phylloquinone",
    "label": "Vitamine K1",
    "unit": "g"
  },
  {
    "key": "beta-glucan",
    "label": "Bêta-glucanes",
    "unit": "g"
  },
  {
    "key": "inositol",
    "label": "inositol",
    "unit": "g"
  },
  {
    "key": "carnitine",
    "label": "Carnitine",
    "unit": "g"
  },
  {
    "key": "melatonin",
    "label": "Melatonin",
    "unit": "µg"
  },
  {
    "key": "methylsulfonylmethane",
    "label": "Methylsulfonylmethane",
    "unit": "mg"
  },
  {
    "key": "nova-group",
    "label": "Groupe NOVA",
    "unit": ""
  },
  {
    "key": "spermidine",
    "label": "Spermidine",
    "unit": ""
  },
  {
    "key": "water",
    "label": "Eau",
    "unit": "g"
  },
  {
    "key": "acidity",
    "label": "Acidité",
    "unit": "% vol"
  },
  {
    "key": "dry-residue",
    "label": "Résidu sec",
    "unit": "mg"
  },
  {
    "key": "beta-alanine",
    "label": "Bêta-Alanine",
    "unit": "g"
  },
  {
    "key": "creatine",
    "label": "Créatine",
    "unit": "g"
  },
  {
    "key": "l-citrulline",
    "label": "L-citruline",
    "unit": "mg"
  },
  {
    "key": "l-glutamine",
    "label": "L-Glutamine",
    "unit": "mg"
  },
  {
    "key": "bcaa",
    "label": "BCAA",
    "unit": "g"
  },
  {
    "key": "l-valine",
    "label": "L-Valine",
    "unit": "mg"
  },
  {
    "key": "l-leucine",
    "label": "L-Leucine",
    "unit": "mg"
  },
  {
    "key": "l-isoleucine",
    "label": "L-Isoleucine",
    "unit": "mg"
  },
  {
    "key": "l-arginine",
    "label": "L-Arginine",
    "unit": "mg"
  },
  {
    "key": "l-cysteine",
    "label": "L-Cysteine",
    "unit": "mg"
  },
  {
    "key": "l-Glutathione",
    "label": "L-Glutathione",
    "unit": "mg"
  },
  {
    "key": "crude fat",
    "label": "matières grasses brutes",
    "unit": "%"
  },
  {
    "key": "crude protein",
    "label": "protéine brute",
    "unit": "%"
  },
  {
    "key": "crude ash",
    "label": "Cendres brutes",
    "unit": "%"
  },
  {
    "key": "crude fibre",
    "label": "Cellulose brute",
    "unit": "%"
  },
  {
    "key": "moisture",
    "label": "humidité",
    "unit": "%"
  },
  {
    "key": "iron II sulphate monohydrate",
    "label": "sulfate de fer II monohydraté",
    "unit": "mg"
  },
  {
    "key": "potassium iodide",
    "label": "iodure de potassium",
    "unit": "mg"
  },
  {
    "key": "copper II sulphate pentahydrate",
    "label": "sulfate de cuivre II pentahydraté",
    "unit": "mg"
  },
  {
    "key": "manganous sulphate monohydrate",
    "label": "sulfate de manganèse monohydraté",
    "unit": "mg"
  },
  {
    "key": "zinc sulphate monohydrate",
    "label": "sulfate de zinc monohydraté",
    "unit": "mg"
  },
  {
    "key": "sodium selenite",
    "label": "sélénite de sodium",
    "unit": "mg"
  },
  {
    "key": "calcium iodate anhydrous",
    "label": "iodate de calcium anhydre",
    "unit": "mg"
  },
  {
    "key": "cassia gum",
    "label": "gomme cassia",
    "unit": "mg"
  },
  {
    "key": "ammonium chloride",
    "label": "chlorure d'ammonium",
    "unit": "mg"
  },
  {
    "key": "choline chloride",
    "label": "chlorure de choline",
    "unit": "mg"
  },
  {
    "key": "protein value",
    "label": "valeur protéique",
    "unit": "g/kg"
  }
]
);

export const OFF_NUTRIENT_MAP = Object.freeze(Object.fromEntries(
  OFF_NUTRIENT_METADATA.map((nutrient) => [nutrient.key, nutrient])
));

export const LEGACY_FOOD_MACRO_KEY_MAP = Object.freeze(
{
  "protein": "proteins",
  "proteins": "proteins",
  "protéines": "proteins",
  "carbs": "carbohydrates",
  "carbohydrates": "carbohydrates",
  "glucides": "carbohydrates",
  "fats": "fat",
  "fat": "fat",
  "lipides": "fat",
  "fibres": "fiber",
  "fiber": "fiber",
  "sucres": "sugars",
  "sugars": "sugars",
  "sucresAjoutés": "added-sugars",
  "added-sugars": "added-sugars",
  "amidon": "starch",
  "starch": "starch",
  "sodium": "sodium",
  "sel": "salt",
  "salt": "salt",
  "acidesSaturés": "saturated-fat",
  "saturated-fat": "saturated-fat",
  "acidesGrasTrans": "trans-fat",
  "trans-fat": "trans-fat",
  "acidesGrasMonoinsaturés": "monounsaturated-fat",
  "monounsaturated-fat": "monounsaturated-fat",
  "acidesGrasPolyinsaturés": "polyunsaturated-fat",
  "polyunsaturated-fat": "polyunsaturated-fat",
  "cholestérol": "cholesterol",
  "cholesterol": "cholesterol",
  "vitamineA": "vitamin-a",
  "vitamin-a": "vitamin-a",
  "vitamineB1": "vitamin-b1",
  "vitamin-b1": "vitamin-b1",
  "vitamineB2": "vitamin-b2",
  "vitamin-b2": "vitamin-b2",
  "vitamineB6": "vitamin-b6",
  "vitamin-b6": "vitamin-b6",
  "vitamineB9": "vitamin-b9",
  "vitamin-b9": "vitamin-b9",
  "vitamineB12": "vitamin-b12",
  "vitamin-b12": "vitamin-b12",
  "vitamineC": "vitamin-c",
  "vitamin-c": "vitamin-c",
  "vitamineD": "vitamin-d",
  "vitamin-d": "vitamin-d",
  "vitamineE": "vitamin-e",
  "vitamin-e": "vitamin-e",
  "vitamineK": "vitamin-k",
  "vitamin-k": "vitamin-k",
  "calcium": "calcium",
  "fer": "iron",
  "iron": "iron",
  "magnésium": "magnesium",
  "magnesium": "magnesium",
  "zinc": "zinc",
  "cuivre": "copper",
  "copper": "copper",
  "manganèse": "manganese",
  "manganese": "manganese",
  "phosphore": "phosphorus",
  "phosphorus": "phosphorus",
  "potassium": "potassium",
  "sélénium": "selenium",
  "selenium": "selenium",
  "choline": "choline",
  "caféine": "caffeine",
  "caffeine": "caffeine",
  "alcool": "alcohol",
  "alcohol": "alcohol",
  "calories": "calories"
}
);

export const DEFAULT_FOOD_MAIN_NUTRIENTS = Object.freeze(
[
  "proteins",
  "carbohydrates",
  "fat",
  "fiber",
  "sodium"
]
);

export const DEFAULT_FOOD_DETAIL_NUTRIENTS = Object.freeze(
[
  "energy-kj",
  "energy-kcal",
  "energy-from-fat",
  "saturated-fat",
  "butyric-acid",
  "caproic-acid",
  "caprylic-acid",
  "capric-acid",
  "lauric-acid",
  "myristic-acid",
  "palmitic-acid",
  "Psicose",
  "stearic-acid",
  "arachidic-acid",
  "behenic-acid",
  "lignoceric-acid",
  "cerotic-acid",
  "montanic-acid",
  "melissic-acid",
  "unsaturated-fat",
  "monounsaturated-fat",
  "polyunsaturated-fat",
  "omega-3-fat",
  "alpha-linolenic-acid",
  "eicosapentaenoic-acid",
  "docosahexaenoic-acid",
  "omega-6-fat",
  "linoleic-acid",
  "arachidonic-acid",
  "gamma-linolenic-acid",
  "dihomo-gamma-linolenic-acid",
  "omega-9-fat",
  "oleic-acid",
  "elaidic-acid",
  "gondoic-acid",
  "mead-acid",
  "erucic-acid",
  "nervonic-acid",
  "trans-fat",
  "cholesterol",
  "gamma-oryzanol",
  "carbohydrates-total",
  "sugars",
  "added-sugars",
  "sucrose",
  "glucose",
  "fructose",
  "oligosaccharide",
  "lactose",
  "galactose",
  "maltose",
  "maltodextrins",
  "starch",
  "Polydextrose",
  "polyols",
  "Erythritol",
  "Isomalt",
  "Maltitol",
  "Sorbitol",
  "soluble-fiber",
  "insoluble-fiber",
  "casein",
  "serum-proteins",
  "nucleotides",
  "salt",
  "added-salt",
  "alcohol",
  "vitamin-a",
  "beta-carotene",
  "vitamin-d",
  "vitamin-e",
  "vitamin-k",
  "vitamin-c",
  "vitamin-b1",
  "vitamin-b2",
  "vitamin-pp",
  "vitamin-b6",
  "vitamin-b9",
  "folates",
  "vitamin-b12",
  "biotin",
  "pantothenic-acid",
  "silica",
  "bicarbonate",
  "Sulphate",
  "Nitrate",
  "Hydrogencarbonate",
  "Nitrite",
  "potassium",
  "chloride",
  "calcium",
  "phosphorus",
  "iron",
  "magnesium",
  "zinc",
  "copper",
  "manganese",
  "fluoride",
  "selenium",
  "chromium",
  "molybdenum",
  "iodine",
  "caffeine",
  "taurine",
  "ph",
  "fruits-vegetables-nuts",
  "fruits-vegetables-nuts-dried",
  "fruits-vegetables-legumes",
  "whole-grain",
  "collagen-meat-protein-ratio",
  "cocoa",
  "chlorophyl",
  "carbon-footprint",
  "glycemic-index",
  "water-hardness",
  "choline",
  "phylloquinone",
  "beta-glucan",
  "inositol",
  "carnitine",
  "melatonin",
  "methylsulfonylmethane",
  "nova-group",
  "spermidine",
  "water",
  "acidity",
  "dry-residue",
  "beta-alanine",
  "creatine",
  "l-citrulline",
  "l-glutamine",
  "bcaa",
  "l-valine",
  "l-leucine",
  "l-isoleucine",
  "l-arginine",
  "l-cysteine",
  "l-Glutathione",
  "crude fat",
  "crude protein",
  "crude ash",
  "crude fibre",
  "moisture",
  "iron II sulphate monohydrate",
  "potassium iodide",
  "copper II sulphate pentahydrate",
  "manganous sulphate monohydrate",
  "zinc sulphate monohydrate",
  "sodium selenite",
  "calcium iodate anhydrous",
  "cassia gum",
  "ammonium chloride",
  "choline chloride",
  "protein value"
]
);

export const DEFAULT_SEARCH_MAIN_NUTRIENTS = Object.freeze(['calories', ...DEFAULT_FOOD_MAIN_NUTRIENTS]);
